import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'
import StickerStatus, { Status } from '../../../../../gif-detail/components/gif/types'
import SuperCutStatus from '../../../../types/super-cut-status'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    height: 50px;
    margin-bottom: 15px;
`

const Topline = styled.div<{ status: Status }>`
    height: 2px;
    background-image: linear-gradient(to right, ${(props) => StickerStatus.gradient(props.status)});
`

const TextContainer = styled.div`
    display: flex;
    align-items: center;
`

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`

const IconContainer = styled.div`
    width: 30px;
    margin: 0px 10px;
`

const ProgressBar = () => {
    const IconComponent = SuperCutStatus.icon(SuperCutStatus.InProgress)

    return (
        <Container>
            <Topline status={Status.Pending} />
            <FlexContainer>
                <IconContainer>
                    <IconComponent />
                </IconContainer>
                <TextContainer>
                    <p style={{ fontWeight: 'bold' }}>Capture In Progress!</p>&nbsp;This capture is currently
                    processing, refresh the page for new scenes.
                </TextContainer>
            </FlexContainer>
        </Container>
    )
}

export default ProgressBar
